var GridColumn = function (props) { return null; };
GridColumn.displayName = 'GridColumn';
export default GridColumn;
//# sourceMappingURL=GridColumn.js.map